import { Box, Typography, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import AlertIcon from '@assets/icons/alertIcon.svg';
import { FirebaseService, CloudFunctionsService } from '@services';
import { globalTheme as theme } from '@styles';

export const Blacklist = observer(() => {
  const { t } = useTranslation('footer');
  const cloudFunctionsService = useMemo(() => new CloudFunctionsService(), []);
  const firebaseService = useMemo(
    () => new FirebaseService(cloudFunctionsService),
    [cloudFunctionsService]
  );
  useEffect(() => {
    const blacklistLog = async () => {
      await firebaseService.blacklistEvent();
    };
    blacklistLog();
  }, [firebaseService, cloudFunctionsService]);

  return (
    <Box
      id="module-blacklist"
      sx={{
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px',
        zIndex: 1001,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          height: '100%',
          width: '100%',
          top: 0,
          left: 0,
          position: 'absolute',
        },
      }}
      height="100%"
    >
      <Box
        sx={{
          display: 'flex',
          textAlign: 'left',
          flexDirection: 'column',
          width: '345px',
          marginTop: '-10%',
          [theme.breakpoints.down('md')]: {
            width: '90%',
          },
        }}
      >
        <img
          style={{ marginBottom: '12px' }}
          src={AlertIcon}
          alt="Alert Icon"
          width="28px"
          height="28px"
        />
        <Typography
          fontSize={'20px'}
          variant={'body1'}
          lineHeight={1.5}
          marginBottom={'8px'}
          fontWeight={600}
          color={theme.palette.text.primary}
        >
          {t('blacklistTitle')}
        </Typography>
        <Typography
          fontWeight={400}
          variant={'body1'}
          fontSize={'14px'}
          lineHeight={1.5}
          color={theme.palette.brandDarkBlue.main}
        >
          {t('blacklistDescription')}
        </Typography>
        <Typography
          sx={{ marginBottom: '10px' }}
          fontWeight={400}
          variant={'body1'}
          fontSize={'14px'}
          lineHeight={1.5}
          color={theme.palette.brandDarkBlue.main}
        >
          {t('blacklistDescriptionTwo')}
        </Typography>
        <Button
          sx={{
            width: '100%',
            height: { xs: '5.5vh', md: '45px' },
            color: 'white',
            fontWeight: 600,
            marginBottom: { xs: '20px', md: '30px' },
            padding: '16px 24px',
          }}
          onClick={() =>
            (window.location.href = 'https://www.allclear.technology/')
          }
          variant="contained"
        >
          {t('buttonLabel')}
        </Button>
        <Trans
          t={t}
          i18nKey="furtherAssistance"
          components={{
            1: (
              <Typography
                variant="body1"
                sx={{
                  fontSize: '14px',
                  lineHeight: 1.5,
                  fontWeight: 400,
                  display: 'inline',
                  width: '100%',
                }}
              />
            ),
            0: (
              <a
                style={{
                  fontWeight: 600,
                  color: '#0099ff',
                  textDecoration: 'underline',
                }}
                href="mailto:cesar@allclear.ai"
              />
            ),
          }}
        />
      </Box>
    </Box>
  );
});
